export const contractors: TableModule = {
    name: "contractors",
    route: "spa.system.contractors",
    columns: [
        {
            name: "name",
            sortable: true,
            pageLink: true,
            mobile: true
        }, {
            name: "email",
            sortable: true,
        }, {
            name: "lead_time_hours",
            sortable: true
        }
    ],
    filters: [
        {
            name: "id",
            column: "contractors.id",
            type: "numeric"
        }
    ],
    quickFilters: [],
    tools: [
        {
            isCreateAction: true,
            ability: ["create", "contractors"]
        },
    ]
}